module.exports = __webpack_public_path__ + "media/images/banner/klook/sp/rental-o_360_360_ko-839b126623c91b4668055e92e2e0b733.jpg";